import { Image, Svg, Text, View } from '@react-pdf/renderer';
import * as React from 'react';
import { PdfCrossCheck, styles } from '../PDFStyle';
import check from '../../../images/check.svg';
import cross from '../../../images/X.svg';
import PDFSmallLetter from '../PDFSmallLetter/PDFSmallLetter';
import SVGCheck from '../PDFLayout/SVGCheck';
import SVGX from '../PDFLayout/SVGX';
import { width } from '@mui/system';
interface IPDFTableHeaderProps {
    columns: string[];
    viewStyle?: any;
    style?: any;
    isHeader?: boolean;
}

const PDFTableHeader = (props: IPDFTableHeaderProps) => {
    const { columns, style, viewStyle } = props;

    return (
        <>
            {columns.map((col, index) => {
                if (col.startsWith('@') && col.includes('(')) {
                    let symbolToSplit = col.split('@');
                    let arrSymbol = symbolToSplit[1].split('(');
                    return (
                        <View style={{ maxWidth: `${100 / columns.length}%`, width: `${100 / columns.length}%` }}>
                            <PDFSmallLetter normal={arrSymbol[0]} small={arrSymbol[1].replace(')', '')} />
                        </View>
                    );
                }
                let textAlign = index === 0 ? 'start' : 'center';
                let oneColumnWidth = 100 / columns.length + 3;
                if (index === 1 && col.includes('ᵀᴹ')) col = col.replace('ᵀᴹ', '\u2122');

                let fontFamily = !props.isHeader && index>0 &&  columns.length!=2 ? 'Noto Sans' : undefined;
                let paddingLeft = `${ index == 0 ? '5px' : '0px'}`;
                let paddingRight = `${ index == columns.length-1 ? '5px' : '0px'}`;
                let width = `${ columns.length == 4 && index == 0 ? oneColumnWidth * 1.6 : columns.length == 2 && index == 0 ? oneColumnWidth+15 : columns.length == 2 ? oneColumnWidth : index == 0 ? oneColumnWidth * 1.8 : oneColumnWidth - 10 }%`;

                return col === PdfCrossCheck.check || col === PdfCrossCheck.cross ? (
                    <View style={[{ fontFamily: fontFamily, paddingLeft: paddingLeft, paddingRight: paddingRight, width: width, maxWidth: width}, styles.imgCenter]} key={col+index}>
                        {col === PdfCrossCheck.check ? <SVGCheck /> : <SVGX />}
                    </View>
                ) : (
                    <Text style={{ fontFamily: fontFamily, paddingLeft: paddingLeft, paddingRight: paddingRight, width: width, maxWidth: width, textAlign: textAlign, ...style }} key={col+index}>
                        {col}
                    </Text>
                );
            })}
        </>
    );
};

export default PDFTableHeader;
